import { render, staticRenderFns } from "./UserSubscription.vue?vue&type=template&id=0af52702&scoped=true&"
import script from "./UserSubscription.vue?vue&type=script&lang=js&"
export * from "./UserSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af52702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af52702')) {
      api.createRecord('0af52702', component.options)
    } else {
      api.reload('0af52702', component.options)
    }
    module.hot.accept("./UserSubscription.vue?vue&type=template&id=0af52702&scoped=true&", function () {
      api.rerender('0af52702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Users/Children/UserSubscription.vue"
export default component.exports